import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ModernSelect as Select } from 'shared/ui/ModernSelect';
import { BaseScale, IncomeStatisticsFilterKeys } from '../../model/types';

interface ScaleSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const ScaleSelect: FC<ScaleSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('contracts');

  const scaleOptions = useMemo<Array<{ label: string; value: BaseScale }>>(() => {
    return [
      { label: t('Days'), value: BaseScale.DAY },
      { label: t('Months'), value: BaseScale.MONTH },
    ];
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(IncomeStatisticsFilterKeys.scale);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Scale')}
      placeholder={t('All')}
      bordered
      allowClear
      options={scaleOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
